export const localStorageFavoritesKey = 'favoritesCurrencies';

export const getFavoritesFromStorage = () => {
  try {
    const storageFavorites = localStorage.getItem(localStorageFavoritesKey);
    return storageFavorites ? JSON.parse(storageFavorites) : [];
  } catch (e) {
    return [];
  }
};
